import {InputBase} from './InputBase';

export class InputTextbox extends InputBase<string>{
    public override controlType:string = 'textbox';
    public override type:string;

    constructor(options:any={}){
        super(options);
        this.type = options['type'] || '';
    }
}